import {Component, OnInit} from '@angular/core';
import {Request} from "../../classes/request";
import {Customer} from "../../classes/customer";
import {ActivatedRoute, Router} from "@angular/router";
import {RequestService} from "../../services/request";
import {CustomerService} from "../../services/customer";
import {ReferrerService} from "../../services/referrer";
import {Referrer} from "../../classes/referrer";
import {SupplierService} from "../../services/supplier";
import {Supplier} from "../../classes/supplier";
import {PartyOption, partyKey, partyOptionList, searchParty, splitPartyKeys} from "../../utils/partyOptions";
import {DocumentService} from "../../services/document";
import {GoogleDriveService} from "../../services/googleDrive";
import {EmailService} from 'src/app/services/email';
import {HttpErrorResponse} from "@angular/common/http";
import {Document} from "../../classes/document";
import {AuthService} from "../../services/auth";
import {saveAs} from "file-saver";
import config from "../../config.json";
import {
    createDefaultDepreciationAssets,
    createEmptyDepreciationAsset,
    initializeDepreciationAssetsState,
    syncDepreciationFieldsForSave
} from "../../utils/depreciationAssets";
import {
    isCustomerDocumentType
} from "../../utils/customerDocuments";
import {
    computeFormattedCaretPosition,
    finalizeItalianAmountOnBlur,
    formatItalianAmountWhileTyping,
    formatNumberToItalianAmount,
    parseItalianAmountToNumber
} from "../../utils/italianAmountInput";

@Component({
    selector: 'app-request-update',
    templateUrl: './request-update.component.html',
    styleUrls: ['./request-update.component.css']
})
export class RequestUpdateComponent implements OnInit {
    request: Request = new Request();
    customer: Customer = new Customer();
    partyOptions: PartyOption[] = [];
    selectedPartyKeys: string[] = [];
    partyLoadError: string = '';
    private loadedReferrers: Array<Referrer> | null = null;
    private loadedSuppliers: Array<Supplier> | null = null;
    loadingCondition: boolean = false;
    currentStep: number = 1;
    private documentsSyncInFlight = false;
    multipleDepreciationRates = false;
    radioBasicOptions = [{value: true, label: 'Sì'}, {value: false, label: 'No'}];
    radioInvestmentModeOptions = ['Leasing', 'Finanziamento'];
    radioTaxCredit5BusinessExpansionOptions: string[] = [ 'Ampliamento Aziendale', 'Sostituzione' ];
    radioInvestmentDurationOptions = ['2', '3', '4', '5'];
    checkboxInvestmentTypeOptions: any = [ 'Ordinario', 'Green', '4.0' ];
    radioStructureOwnerOptions: string[] = [ 'Affittuaria', 'Proprietaria' ];
    checkboxInvestmentTypeValues: any = [ false, false, false ];
    /** Valore visualizzato per l'importo investimento (formato italiano). */
    investmentAmountDisplay = '';
    private previousInvestmentAmountDisplay = '';
    fileName: any = {
        1: '',
        2: '',
        3: '',
        4: '',
        5: '',
        6: '',
        7: '',
        8: '',
        9: '',
        10: '',
        11: '',
        12: '',
        13: '',
        14: '',
        15: '',
        16: '',
        17: '',
        29: ''
    };
    fileData: any = {
        1: new FormData(),
        2: new FormData(),
        3: new FormData(),
        4: new FormData(),
        5: new FormData(),
        6: new FormData(),
        7: new FormData(),
        8: new FormData(),
        9: new FormData(),
        10: new FormData(),
        11: new FormData(),
        12: new FormData(),
        13: new FormData(),
        14: new FormData(),
        15: new FormData(),
        16: new FormData(),
        17: new FormData(),
        29: new FormData()
    };
    documentList: any = {
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
        6: [],
        7: [],
        8: [],
        9: [],
        10: [],
        11: [],
        12: [],
        13: [],
        14: [],
        15: [],
        16: [],
        17: [],
        29: []
    };
    documentTypeName: any = {
        1: 'VISURA',
        2: 'BILANCIO',
        3: 'MARCA_BOLLO',
        4: 'CARTA_IDENTITA',
        5: 'OFFERTA',
        6: 'CONTRATTO_LIBERATORIA_PROCURA_PRIVACY',
        7: 'PAGAMENTO',
        8: 'DURC',
        9: 'REGISTRI_IVA',
        10: 'FATTURE',
        11: 'PERIZIA_4',
        12: 'CARTA_IDENTITA_PERITO_4',
        13: 'CERTIFICAZIONE_EX_ANTE_5',
        14: 'CARTA_IDENTITA_ING_ENERGETICO',
        15: 'LIBRO_CESPITI',
        16: 'VISURA_STRUTTURA',
        17: 'CONTRATTO_AFFITTO_STRUTTURA',
        29: 'DVR'
    };

    constructor(private route: ActivatedRoute,
                private router: Router,
                private authService: AuthService,
                private requestService: RequestService,
                private customerService: CustomerService,
                private referrerService: ReferrerService,
                private supplierService: SupplierService,
                private documentService: DocumentService,
                private emailService: EmailService,
                private googleDriveService: GoogleDriveService) { }

    searchPartyOption = searchParty;

    onPartiesChange(keys: string[] | null): void {
        this.selectedPartyKeys = keys || [];
        if (this.request.IDRequest === undefined) {
            return;
        }
        const parties = splitPartyKeys(this.selectedPartyKeys);
        this.request.ReferrerIDs = parties.referrerIds;
        this.request.SupplierIDs = parties.supplierIds;
    }

    private publishPartyOptions(): void {
        this.partyOptions = partyOptionList(this.loadedReferrers || [], this.loadedSuppliers || []);
    }

    get birthDateString(): string {
        const normalizedBirthDate = this.normalizeBirthDateToUtcMidnight(this.customer.BirthDate);
        if (!normalizedBirthDate) {
            return '';
        }
        const date = normalizedBirthDate;
        // Uso metodi UTC per evitare che il fuso orario sposti la data di un giorno (es. UTC-5)
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const day = String(date.getUTCDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    set birthDateString(value: string) {
        if (!value) {
            this.customer.BirthDate = null;
            return;
        }
        // Parsing esplicito YYYY-MM-DD come data di calendario (mezzanotte UTC) per evitare sfasamenti
        const [y, m, d] = value.split('-').map(Number);
        this.customer.BirthDate = new Date(Date.UTC(y, m - 1, d));
    }

    private normalizeBirthDateToUtcMidnight(date: Date | string | null): Date | null {
        if (date == null) {
            return null;
        }

        if (typeof date === 'string') {
            const normalizedDateParts = date.match(/^(\d{4})-(\d{2})-(\d{2})/);
            if (normalizedDateParts) {
                const [, year, month, day] = normalizedDateParts;
                return new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
            }
        }

        const parsedDate = new Date(date);
        if (isNaN(parsedDate.getTime())) {
            return null;
        }
        return new Date(Date.UTC(
            parsedDate.getUTCFullYear(),
            parsedDate.getUTCMonth(),
            parsedDate.getUTCDate()
        ));
    }

    ngOnInit(): void {
        this.referrerService.getAll()
            .subscribe({
                next: (referrers: Array<Referrer>) => {
                    this.loadedReferrers = referrers;
                    this.publishPartyOptions();
                },
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                    this.loadedReferrers = [];
                    this.partyLoadError = 'Non è stato possibile caricare i segnalatori.';
                    this.publishPartyOptions();
                }
            });

        this.supplierService.getAll()
            .subscribe({
                next: (suppliers: Array<Supplier>) => {
                    this.loadedSuppliers = suppliers;
                    this.publishPartyOptions();
                },
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                    this.loadedSuppliers = [];
                    this.partyLoadError = this.partyLoadError || 'Non è stato possibile caricare i fornitori.';
                    this.publishPartyOptions();
                }
            });

        this.authService.isUserSignedIn()
            .subscribe({
                error: () => {
                    this.router.navigate(['/login']);
                }
            });

        this.route.paramMap.subscribe(params => {
            this.requestService.getByID(params.get('id'))
                .subscribe({
                    next: (request: Request) => {
                        this.request = request;
                        const referrerIds = Array.isArray(request.referrers)
                            ? request.referrers
                                .map(referrer => referrer.IDReferrer)
                                .filter((id): id is number => typeof id === 'number')
                            : [];
                        const supplierIds = Array.isArray(request.suppliers)
                            ? request.suppliers
                                .map(supplier => supplier.IDSupplier)
                                .filter((id): id is number => typeof id === 'number')
                            : [];
                        if (Array.isArray(request.referrers)) {
                            this.request.ReferrerIDs = referrerIds.slice();
                        }
                        if (Array.isArray(request.suppliers)) {
                            this.request.SupplierIDs = supplierIds.slice();
                        }
                        this.selectedPartyKeys = referrerIds.map(id => partyKey('referrer', id))
                            .concat(supplierIds.map(id => partyKey('supplier', id)));
                        this.request.InitialAcceptance = true;
                        this.initCustomerFromRequest(request);
                        if (this.request.FKIDRequestType === 5 || this.request.FKIDRequestType === 7) {
                            this.radioInvestmentModeOptions.push('Fondi Propri');
                        }
                        if (this.request.FKIDRequestType === 7) {
                            this.radioInvestmentDurationOptions.push('6');
                            this.radioInvestmentDurationOptions.push('7');
                            this.radioInvestmentDurationOptions.push('8');
                        }
                        let requestInvestmentTypes = this.request.InvestmentType?.split(',');
                        if (requestInvestmentTypes !== undefined && requestInvestmentTypes !== null) {
                            requestInvestmentTypes.forEach((requestInvestmentType: string) => {
                                const indexFound = this.checkboxInvestmentTypeOptions.findIndex((checkboxInvestmentTypeOption: string) => {
                                    return checkboxInvestmentTypeOption === requestInvestmentType;
                                });
                                if (indexFound > -1) {
                                    this.checkboxInvestmentTypeValues[indexFound] = true;
                                }
                            });
                        }
                        if (this.request.FKIDRequestType === 6 || this.request.FKIDRequestType === 7) {
                            this.checkboxInvestmentTypeValues[2] = true;
                        }
                        this.multipleDepreciationRates = initializeDepreciationAssetsState(this.request);
                        this.investmentAmountDisplay = formatNumberToItalianAmount(this.request.InvestmentAmount);
                        this.previousInvestmentAmountDisplay = this.investmentAmountDisplay;
                        this.onEnterDocumentsStep();
                    },
                    error: (err: HttpErrorResponse) => {
                        console.log(err);
                    }
                });
        });
    }

    /**
     * La lista mostra i documenti della pratica: solo-richiesta e satelliti dei master
     * cliente. I master non compaiono, così il cestino agisce sempre sulla copia della pratica.
     */
    private refreshDocumentLists(): void {
        if (!this.request.IDRequest) {
            return;
        }
        this.documentService.getAllByIDRequest(this.request.IDRequest.toString())
            .subscribe({
                next: (documentList: any) => {
                    this.mergeDocumentList(documentList);
                },
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                }
            });
    }

    goToStep(newStep: number) {
        if (this.currentStep !== newStep) {
            this.saveCurrentStepData();
        }
        this.currentStep = newStep;
        if (newStep === 3) {
            this.onEnterDocumentsStep();
        }
    }

    saveAndGoToDashboard() {
        this.saveCurrentStepData();
        this.router.navigate(['/dashboard']);
    }

    downloadDocumentsToSign() {
        this.documentService.downloadDocumentsToSign(this.request.IDRequest!.toString())
            .subscribe({
                next: (blobFile) => {
                    saveAs(blobFile, ((this.request.FKIDRequestType !== 5) ? "Contratto Liberatoria Procura Privacy.pdf" : "Contratto di consulenza.pdf"));
                },
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                }
            });
    }

    uploadDocument(event: any, idDocumentType: number) {
        if (this.loadingCondition) {
            return;
        }
        const files: Array<File> = event.target.files;
        if (!files || files.length === 0) {
            return;
        }

        this.loadingCondition = true;
        this.fileData[idDocumentType] = new FormData();
        for (let i = 0; i < files.length; i++) {
            this.fileData[idDocumentType].append('uploadFile', files[i]);
        }
        this.fileName[idDocumentType] = (files.length === 1) ? files[0].name : files.length + ' file selezionati';
        let documentIncrementalPart = '';
        if (idDocumentType === 4 || idDocumentType === 5) {
            let maxDocumentIndex = 0;
            this.documentList[idDocumentType].forEach((currentDocument: any)=> {
                let currentDocumentPathParts = currentDocument.Path.split("---")[0].split("_");
                let currentDocumentIndex = parseInt(currentDocumentPathParts[currentDocumentPathParts.length - 1]);
                if (currentDocumentIndex > maxDocumentIndex) {
                    maxDocumentIndex = currentDocumentIndex;
                }
            });
            documentIncrementalPart = "_" + (maxDocumentIndex + 1);
        }

        this.fileData[idDocumentType].set('IDDocumentType', idDocumentType.toString());
        this.fileData[idDocumentType].set('IDRequest', this.request.IDRequest!.toString());
        this.fileData[idDocumentType].set('FKIDRequestType', this.request.FKIDRequestType!.toString());
        if (isCustomerDocumentType(idDocumentType) && this.request.FKIDCustomer) {
            this.fileData[idDocumentType].set('IDCustomer', this.request.FKIDCustomer.toString());
        }
        const vatForFilePath = this.customer?.VATNumber || '';
        let fileNameParts: Array<string> = this.fileName[idDocumentType].split(".");
        this.fileData[idDocumentType].set('FilePath', this.documentTypeName[idDocumentType] + documentIncrementalPart + '---' +
            vatForFilePath + '_' + this.request.IDRequest!.toString() + '.' + fileNameParts[fileNameParts.length - 1]);
        this.documentService.create(this.fileData[idDocumentType])
            .subscribe({
                next: ((documentsCreated: any) => {
                    if (!this.documentList[idDocumentType]) {
                        this.documentList[idDocumentType] = [];
                    }
                    // Per i tipi cliente la create risponde con il master, che qui non va mostrato:
                    // la riga giusta è il satellite e arriva dal refresh.
                    if (isCustomerDocumentType(idDocumentType)) {
                        this.refreshDocumentLists();
                    } else {
                        this.documentList[idDocumentType].push(...documentsCreated);
                    }
                    this.fileData[idDocumentType] = new FormData();
                    this.fileName[idDocumentType] = '';
                    this.loadingCondition = false;
                }),
                error: ((err: HttpErrorResponse) => {
                    console.log(err);
                    this.loadingCondition = false;
                })
            });
    }

    deleteDocument(document: Document) {
        this.loadingCondition = true;
        this.documentService.deleteRequestDocument(document.IDDocument)
            .subscribe({
                next: (() => {
                    this.documentList[document.FKIDDocumentType!] = this.documentList[document.FKIDDocumentType!].filter((currentDocument: Document) => {
                        return document.IDDocument !== currentDocument.IDDocument;
                    });
                    this.loadingCondition = false;
                    if (isCustomerDocumentType(document.FKIDDocumentType)) {
                        this.refreshDocumentLists();
                    }
                }),
                error: ((err: HttpErrorResponse) => {
                    console.log(err);
                    this.loadingCondition = false;
                })
            });
    }

    completeRequest() {
        this.prepareInvestmentDataForSave();
        this.request.ProgressStatus = 10;
        this.requestService.update(this.request)
            .subscribe({
                next: () => {
                    const email = {
                        to: (config as { mailConfirmationRequest?: string }).mailConfirmationRequest,
                        subject: `Completamento Pratica n. ${this.request.IDRequest} - "${this.customer.CompanyName || ''}"`,
                        html: `Con la presente notifica si avvisa che la pratica numero ${this.request.IDRequest} sul portale Tevanpal è stata completata.`
                    };
                    this.emailService.send(email)
                        .subscribe({
                            next: () => {
                                this.router.navigate(['/dashboard']);
                            },
                            error: (err: HttpErrorResponse) => {
                                console.log(err);
                            }
                        });

                    this.documentService.uploadExportFile(this.request.IDRequest!.toString())
                        .subscribe({
                            error: (err: HttpErrorResponse) => {
                                console.log(err);
                            }
                        });

                    this.documentService.downloadRecapDocument(this.request.IDRequest!.toString())
                        .subscribe({
                            next: (blobFile) => {
                                saveAs(blobFile, "Riepilogo Pratica - Tevanpal.pdf");
                            },
                            error: (err: HttpErrorResponse) => {
                                console.log(err);
                            }
                        });
                },
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                }
            });
    }

    valueChangeInvestmentType(investmentTypeIndex: number) {
        this.checkboxInvestmentTypeValues[investmentTypeIndex] = !this.checkboxInvestmentTypeValues[investmentTypeIndex];
    }

    onPasteIBAN(event: any) {
        let ibanPasted = event.clipboardData.getData('text');
        ibanPasted = ibanPasted.replace(/ /g, "");
        ibanPasted = ibanPasted.substring(0, 27).toUpperCase();
        this.customer.IBAN = ibanPasted;
    }

    onChangeIBAN(event: any) {
        this.customer.IBAN = event.replace(/ /g, "").toUpperCase();
    }

    checkCompleteRequest(): boolean {
        return this.getMissingDocumentsForComplete().length > 0;
    }

    onMultipleDepreciationRatesChange(checked: boolean): void {
        this.multipleDepreciationRates = checked;
        if (checked) {
            this.request.DepreciationRate = null;
            if (!this.request.DepreciationAssets?.length) {
                this.request.DepreciationAssets = createDefaultDepreciationAssets();
            }
        } else {
            this.request.DepreciationAssets = null;
        }
    }

    addDepreciationAsset(): void {
        if (!this.request.DepreciationAssets) {
            this.request.DepreciationAssets = [createEmptyDepreciationAsset()];
            return;
        }
        this.request.DepreciationAssets.push(createEmptyDepreciationAsset());
    }

    removeDepreciationAsset(index: number): void {
        if (!this.request.DepreciationAssets || this.request.DepreciationAssets.length <= 2) {
            return;
        }
        this.request.DepreciationAssets.splice(index, 1);
    }

    private mergeDocumentList(documentList: any): void {
        Object.keys(this.documentList).forEach((key) => {
            this.documentList[key] = documentList?.[key] ?? [];
        });
    }

    private hasUploadedDocuments(id: number): boolean {
        return (this.documentList[id]?.length ?? 0) > 0;
    }

    private isDocumentRequiredForComplete(id: number): boolean {
        const requestType = this.request.FKIDRequestType;
        const simplified = !!this.request.Simplified;

        switch (id) {
            case 1:
            case 2:
            case 4:
                return (requestType === 1 || requestType === 2 || requestType === 3 || requestType === 4 || requestType === 5)
                    && !simplified;
            case 3:
                return requestType !== 5 && requestType !== 7;
            case 5:
            case 6:
            case 7:
                return true;
            case 8:
                return requestType === 5 || requestType === 6 || requestType === 7;
            case 10:
            case 15:
                return requestType === 5 && this.request.TaxCredit5BusinessExpansion === 'Sostituzione';
            case 16:
                return requestType === 5 || ((requestType === 6 || requestType === 7) && !simplified);
            case 17:
                return requestType === 5 && this.request.TaxCredit5StructureOwner === 'Affittuaria';
            case 29:
                return (requestType === 6 || requestType === 7) && !simplified;
            default:
                return false;
        }
    }

    private getMissingDocumentsForComplete(): number[] {
        const documentTypeIds = [1, 2, 3, 4, 5, 6, 7, 8, 10, 15, 16, 17, 29];
        return documentTypeIds.filter((id) =>
            this.isDocumentRequiredForComplete(id) && !this.hasUploadedDocuments(id)
        );
    }

    private saveCurrentStepData(): void {
        switch (this.currentStep) {
            case 1:
                this.saveCompanyStepData();
                break;
            case 2:
                this.saveInvestmentStepData();
                break;
            case 3:
                this.prepareInvestmentDataForSave();
                this.persistRequest();
                break;
        }
    }

    private saveCompanyStepData(): void {
        this.saveCustomer(() => {
            this.ensureDriveFolderThenPersistRequest();
        });
    }

    private getCustomerDriveFolderName(): string {
        const companyName = this.customer.CompanyName || 'Cliente';
        const vatNumber = this.customer.VATNumber || '';
        return companyName + '---' + vatNumber + '_' + this.request.IDRequest!.toString();
    }

    /** Inizializza il customer da include API o da getByID. */
    private initCustomerFromRequest(request: Request): void {
        if (request.customer) {
            this.customer = request.customer;
            this.customer.BirthDate = this.normalizeBirthDateToUtcMidnight(this.customer.BirthDate);
            return;
        }

        if (request.FKIDCustomer) {
            this.loadCustomerForRequest();
            return;
        }

        this.customer = new Customer();
    }

    private loadCustomerForRequest(): void {
        if (!this.request.FKIDCustomer) {
            return;
        }
        this.customerService.getByID(this.request.FKIDCustomer.toString())
            .subscribe({
                next: (customer: Customer) => {
                    this.customer = customer;
                    this.customer.BirthDate = this.normalizeBirthDateToUtcMidnight(this.customer.BirthDate);
                },
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                }
            });
    }

    /** Persistenza customer: update se esiste, create altrimenti (+ collega FKIDCustomer). */
    private saveCustomer(onDone: () => void): void {
        if (this.request.FKIDCustomer && !this.customer.IDCustomer) {
            this.customer.IDCustomer = this.request.FKIDCustomer;
        }

        if (this.customer.IDCustomer) {
            this.customerService.update(this.customer)
                .subscribe({
                    next: () => {
                        this.request.FKIDCustomer = this.customer.IDCustomer;
                        onDone();
                    },
                    error: (err: HttpErrorResponse) => {
                        console.log(err);
                        onDone();
                    }
                });
            return;
        }

        this.customerService.create(this.customer)
            .subscribe({
                next: (createdCustomer: Customer) => {
                    this.customer = createdCustomer;
                    this.customer.BirthDate = this.normalizeBirthDateToUtcMidnight(this.customer.BirthDate);
                    this.request.FKIDCustomer = createdCustomer.IDCustomer;
                    this.syncDepreciationBeforeSave();
                    this.requestService.update(this.request)
                        .subscribe({
                            next: () => onDone(),
                            error: (err: HttpErrorResponse) => {
                                console.log(err);
                                onDone();
                            }
                        });
                },
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                    onDone();
                }
            });
    }

    private ensureDriveFolderThenPersistRequest(): void {
        const driveFolderName = this.getCustomerDriveFolderName();
        if (this.request.IDFolderGoogleDrive === null || this.request.IDFolderGoogleDrive === '') {
            if (this.request.FKIDRequestType !== 5 && this.request.FKIDRequestType !== 6) {
                this.googleDriveService.createFolder(null, driveFolderName, this.request.FKIDRequestType!)
                    .subscribe({
                        next: (folderCreated: any) => {
                            this.request.IDFolderGoogleDrive = folderCreated.IDFolder;
                            this.persistRequest();
                        },
                        error: (err: HttpErrorResponse) => {
                            console.log(err);
                        }
                    });
            } else if (this.request.FKIDRequestType === 5) {
                this.googleDriveService.createFolder(null, driveFolderName, this.request.FKIDRequestType)
                    .subscribe({
                        next: (folderCreated: any) => {
                            this.googleDriveService.createFolder(folderCreated.IDFolder, "Documenti caricati dai professionisti", this.request.FKIDRequestType!)
                                .subscribe({
                                    next: (folderProfessionalsCreated: any) => {
                                        this.request.IDFolderGoogleDrive = folderCreated.IDFolder;
                                        this.request.IDFolderGoogleDriveSecondary = folderProfessionalsCreated.IDFolder;
                                        this.persistRequest();
                                    },
                                    error: (err: HttpErrorResponse) => {
                                        console.log(err);
                                    }
                                });
                        },
                        error: (err: HttpErrorResponse) => {
                            console.log(err);
                        }
                    });
            } else if (this.request.FKIDRequestType === 6) {
                this.googleDriveService.createFolder(null, driveFolderName, this.request.FKIDRequestType!)
                    .subscribe({
                        next: (folderCreated: any) => {
                            this.request.IDFolderGoogleDrive = folderCreated.IDFolderDNS;
                            this.request.IDFolderGoogleDriveSecondary = folderCreated.IDFolderIP4;
                            this.persistRequest();
                        },
                        error: (err: HttpErrorResponse) => {
                            console.log(err);
                        }
                    });
            }
        } else {
            this.persistRequest();
        }
    }

    /**
     * All'ingresso della pagina e dello step Documenti: se manca il satellite
     * di un tipo cliente, lo ricrea dal master attuale. Non tocca i satelliti già presenti.
     */
    private onEnterDocumentsStep(): void {
        if (!this.request.IDRequest || !this.request.FKIDCustomer || !this.request.IDFolderGoogleDrive) {
            this.refreshDocumentLists();
            return;
        }
        if (this.documentsSyncInFlight) {
            return;
        }

        this.documentsSyncInFlight = true;
        this.documentService.syncCustomerDocumentsToRequest({
            IDRequest: this.request.IDRequest,
            IDCustomer: this.request.FKIDCustomer,
            IDFolderGoogleDrive: this.request.IDFolderGoogleDrive,
            IDFolderGoogleDriveSecondary: this.request.IDFolderGoogleDriveSecondary || null
        }).subscribe({
            next: () => {
                this.documentsSyncInFlight = false;
                this.refreshDocumentLists();
            },
            error: (err: HttpErrorResponse) => {
                this.documentsSyncInFlight = false;
                console.log(err);
                this.refreshDocumentLists();
            }
        });
    }

    private saveInvestmentStepData(): void {
        this.request.PrivacyAcceptance = true;
        this.request.WarrantAcceptance = true;
        this.request.AttorneyAcceptance = true;
        this.prepareInvestmentDataForSave();
        this.persistRequest();
    }

    private prepareInvestmentDataForSave(): void {
        this.syncDepreciationBeforeSave();

        const requestInvestmentType: string[] = [];
        this.checkboxInvestmentTypeValues.forEach((checkboxInvestmentTypeValue: boolean, index: number) => {
            if (checkboxInvestmentTypeValue) {
                requestInvestmentType.push(this.checkboxInvestmentTypeOptions[index]);
            }
        });
        this.request.InvestmentType = requestInvestmentType.join(',');
        this.syncInvestmentAmountFromDisplay(true);
    }

    onInvestmentAmountKeyDown(event: KeyboardEvent): void {
        const inputEl = event.target as HTMLInputElement | null;
        if (!inputEl) {
            return;
        }
        const start = inputEl.selectionStart;
        const end = inputEl.selectionEnd;
        if (start === null || end === null || start !== end) {
            return;
        }

        if (event.key === 'Backspace' && start > 0 && inputEl.value[start - 1] === '.') {
            inputEl.setSelectionRange(start - 1, start - 1);
        } else if (event.key === 'Delete' && start < inputEl.value.length && inputEl.value[start] === '.') {
            inputEl.setSelectionRange(start + 1, start + 1);
        }
    }

    onInvestmentAmountInput(event?: Event): void {
        const inputEl = event?.target as HTMLInputElement | null | undefined;
        const raw = inputEl?.value ?? this.investmentAmountDisplay;
        const rawCaret = inputEl?.selectionStart ?? raw.length;
        const inputData = (event as InputEvent | undefined)?.data;

        let newlyTypedDecimalIndex: number | null = null;
        if (inputData === '.' || inputData === ',') {
            newlyTypedDecimalIndex = rawCaret > 0
                ? rawCaret - 1
                : raw.lastIndexOf(inputData);
        }

        const formatted = formatItalianAmountWhileTyping(
            raw,
            this.previousInvestmentAmountDisplay,
            newlyTypedDecimalIndex
        );
        const nextCaret = computeFormattedCaretPosition(
            raw,
            rawCaret,
            formatted,
            this.previousInvestmentAmountDisplay,
            newlyTypedDecimalIndex
        );

        this.investmentAmountDisplay = formatted;
        this.previousInvestmentAmountDisplay = formatted;
        this.request.InvestmentAmount = parseItalianAmountToNumber(formatted);
        if (inputEl) {
            if (inputEl.value !== formatted) {
                inputEl.value = formatted;
            }
            inputEl.setSelectionRange(nextCaret, nextCaret);
            setTimeout(() => {
                if (document.activeElement === inputEl) {
                    inputEl.setSelectionRange(nextCaret, nextCaret);
                }
            });
        }
    }

    onInvestmentAmountBlur(): void {
        this.syncInvestmentAmountFromDisplay(true);
    }

    private syncInvestmentAmountFromDisplay(finalizeOnBlur: boolean): void {
        if (finalizeOnBlur) {
            this.investmentAmountDisplay = finalizeItalianAmountOnBlur(this.investmentAmountDisplay);
        }
        this.previousInvestmentAmountDisplay = this.investmentAmountDisplay;
        this.request.InvestmentAmount = parseItalianAmountToNumber(this.investmentAmountDisplay);
    }

    private persistRequest(): void {
        this.syncDepreciationBeforeSave();
        this.requestService.update(this.request)
            .subscribe({
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                }
            });
    }

    private syncDepreciationBeforeSave(): void {
        syncDepreciationFieldsForSave(this.request, this.multipleDepreciationRates);
    }

}
